import React, {
  useState,useEffect,useContext,
} from "react";
import RTUtilisateurs from "components/RTUtilisateurs/RTUtilisateurs";
import Permissions from "components/Permissions/Permissions";
import Vues from "components/Vues/Vues";
import RTCharts from "components/RTCharts/RTCharts";
// import Vuesold from "components/Vues copy/Vues";
import UtilisateursTabs from "components/UtilisateursTabs/UtilisateursTabs";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import postPageVisit from "services/LogService";

export default function Utilisateurs() {
  const currentusertype = localStorage.getItem('userType');
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;

  useEffect(() => {
    setPage('users');
    postPageVisit('users');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/utilisateurs",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"utilisateurs"}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>


              <UtilisateursTabs
                utilisateurs={<RTUtilisateurs />}
                permissions={<Permissions />}
                vues={ <Vues />}
                charts={<RTCharts/>}
              />


            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
